import React, { useContext } from "react";
import { ExchangeRateContext } from "../App";

const BuyCard = ({ amount, onBuyClick }) => {
    const { exchangeRate } = useContext(ExchangeRateContext);
    const calculate6DO = (amount) => (exchangeRate ? (amount * exchangeRate).toFixed(2) : 0);
    const link = process.env[`REACT_APP_STRIPE_LINK_${amount}`];
    const isPopular = amount === 50; // For conditional "Most Popular" badge
    const isOnFire = amount === 10;  // For conditional "On Fire" badge

    return (
        <div className="col-md-3 mb-4">
            <div className="card text-center fixed-height-card" onClick={onBuyClick}>
                <div className="card-body">
                    <h5 className="card-title">Buy {calculate6DO(amount)} 6DO</h5>
                    {isOnFire && <span className="badge bg-danger">🔥 On Fire</span>}
                    {isPopular && <span className="badge bg-warning">⭐ Most Popular</span>}
                    {!isOnFire && !isPopular && (<span className="badge invisible">Placeholder</span>)}
                    <p className="card-text">For ${amount}</p>
                    <img
                        src="/assets/6DO_icon_minified.png"
                        alt="6DO Icon"
                        style={{ width: "200px" }}
                        className="img-fluid mb-3"
                    />
                    <div className="btn btn-primary">Buy Now</div>
                </div>
            </div>
        </div>
    );
};

export default BuyCard;
